import { RETRIEVE_TOKEN_NOT_FOUND } from '../../const/email_const';

export const getErrorDescription = (error) => {
  if (error === RETRIEVE_TOKEN_NOT_FOUND) {
    return 'Invalid Verification Token';
  } else {
    return 'Email Verification Failed';
  }
};



// WEBPACK FOOTER //
// ./src/components/EmailUpdateConfirmationModal/EmailUpdateConfirmationUtil.jsx